import { z } from 'zod'
import { bzOptional } from '../../domain/common-schemas'

export const JobCostingCompanyConfigSchema = z.object({
  enabled: z.boolean(),
  fieldJobCostReviewRequired: z.boolean(),
})

export type JobCostingCompanyConfig = z.infer<typeof JobCostingCompanyConfigSchema>

export const JobCostingCompanyConfigPatchSchema = z
  .object({
    enabled: bzOptional(z.boolean()),
    fieldJobCostReviewRequired: bzOptional(z.boolean()),
  })
  .refine(patch => Object.values(patch).some(value => value !== undefined), {
    message: 'At least one field must be provided',
  })

export type JobCostingCompanyConfigPatch = z.infer<typeof JobCostingCompanyConfigPatchSchema>
